import { fetchWithOrganization } from "./organizationRequest";

function normalizeBaseUrl(url) {
	return String(url || "").trim().replace(/\/$/, "");
}


function getCalendarBaseUrl() {
    return normalizeBaseUrl(process.env.REACT_APP_CALENDAR_BASE_URL || "http://localhost:8087");
}

const CALENDAR_BASE_URL = getCalendarBaseUrl();
const SERVICE_BASE_URL = normalizeBaseUrl(process.env.REACT_APP_SERVICE_API_URL || "http://localhost:8085");

function buildCalendarUrl(path) {
    const baseUrl = CALENDAR_BASE_URL;
    const normalizedPath = String(path || "").trim().replace(/^\//, "");
    return `${baseUrl}/calendar/${normalizedPath}`;
}

function buildServiceUrl(path) {
    const normalizedPath = String(path || "").trim().replace(/^\//, "");
    return `${SERVICE_BASE_URL}/service/${normalizedPath}`;
}

export async function requestJson(path, options = {}) {
    const response = await fetchWithOrganization(buildCalendarUrl(path), {
        credentials: "include",
        ...options,
    });

    let payload = {};
    try {
        payload = await response.json();
    } catch {
        payload = {};
    }

    return { response, payload };
}

export async function requestServiceJson(path, options = {}) {
    const response = await fetchWithOrganization(buildServiceUrl(path), {
        credentials: "include",
        ...options,
    });

    let payload = {};
    try {
        payload = await response.json();
    } catch {
        payload = {};
    }

    return { response, payload };
}

export function assertOk(response, payload, fallbackMessage) {
    if (!response.ok) {
        const message = payload?.error || fallbackMessage;
        const detail = response.status ? `${message} (${response.status})` : message;
        const error = new Error(detail);
        error.status = response.status;
        error.payload = payload;
        throw error;
    }

    return payload;
}

export async function fetchAppointments(userID, month) {
    const { response, payload } = await requestJson(`appointments/${encodeURIComponent(userID)}/${encodeURIComponent(month)}`);
    return assertOk(response, payload, "Failed to fetch appointments");
}

export async function deleteAppointment(appointmentID) {
    const response = await fetchWithOrganization(
        `${CALENDAR_BASE_URL}/calendar/appointments/${encodeURIComponent(appointmentID)}`,
        { method: "DELETE", credentials: "include" },
    );

    let payload = {};
    try {
        payload = await response.json();
    } catch {
        payload = {};
    }

    return assertOk(response, payload, "Failed to delete appointment");
}

export async function cancelAppointment(appointmentID) {
    const { response, payload } = await requestJson(
        `appointments/cancel/${encodeURIComponent(appointmentID)}`,
        { method: "PUT" },
    );

    return assertOk(response, payload, "Failed to cancel appointment");
}

export async function markAppointmentPaidCash(appointmentID) {
    const { response, payload } = await requestJson(
        `appointments/cash/${encodeURIComponent(appointmentID)}`,
        { method: "PUT" },
    );

    return assertOk(response, payload, "Failed to mark appointment paid with cash");
}

export async function editAppointment(appointmentID, services) {
    const { response, payload } = await requestJson(
        `appointments/edit/${encodeURIComponent(appointmentID)}`,
        {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ services }),
        },
    );

    return assertOk(response, payload, "Failed to edit appointment");
}

export async function issueConfirmToken(hashedAppointmentID) {
    const { response, payload } = await requestServiceJson(
        `payments/appointments/${encodeURIComponent(hashedAppointmentID)}/confirm-token`,
        { method: "POST" },
    );

    return assertOk(response, payload, "Failed to issue confirm link");
}


export async function CaptureRemainingBalance(AppointmentID) {
    const { response, payload } = await requestServiceJson(
        `payments/appointments/confirm/${encodeURIComponent(AppointmentID)}`,
        { method: "POST" },
    );

    return assertOk(response, payload, "Failed to capture remaining balance");
}

export async function getAppointmentPaymentTotal(appointmentID) {
    const { response, payload } = await requestServiceJson(
        `payments/appointments/total/${encodeURIComponent(appointmentID)}`,
        { method: "GET" },
    );

    return assertOk(response, payload, "Failed to fetch appointment payment total");
}

export async function addTipToAppointment(appointmentID, type, value) {
    const { response, payload } = await requestServiceJson(
        `payments/appointments/addTip/${encodeURIComponent(appointmentID)}`,
        {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ type, value }),
        },
    );

    return assertOk(response, payload, "Failed to add appointment tip");
}